var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-product-layout',{attrs:{"title":"ویرایش محصول","submitFunction":_vm.UpdateProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }